<div id="error-box">
  <div *ngIf="notFind"><img src="{{assetsRoute}}/picture/404.png" /> </div>
  <div *ngIf="loadError || otherError || accessError"><img src="{{assetsRoute}}/picture/500.png" /> </div>
  <div class="error-text" *ngIf="notFind">啊哦，页面好像找不到了...</div>
  <div class="error-text" *ngIf="loadError || otherError">哎呀，加载失败了...</div>
  <div class="error-text" *ngIf="accessError">你没有该功能的权限</div>
  <div class="button-holder" *ngIf="!accessError">
    <button *ngIf="otherError" id="refreshBtn" class="btnWord" (click)="refresh();">点击重试</button>
    <button *ngIf="!otherError" id="refreshBtn" class="btnWord" (click)="goHome();">返回英跃学堂</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-error/app-error.component.html